import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';

const HistorialMarcarioComponent = (props) => {
    const historial = props.historial

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        height: '30',
        bgcolor: '#E3EFF1',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black'
    };

    const [openModalHistorial, setOpenModalHistorial] = React.useState(true)

    const handleCloseModal = () => {
        setOpenModalHistorial(false)
        props.setOpenModalHistorial.setOpenModalHistorial()
    }

    const columns = [
        {
            field: 'informe', headerName: 'Informe', headerAlign: 'center', flex: .5,
            renderCell: (params) =>
                <Tooltip title={`${params.row.informe}`} arrow>
                    <label>{`${params.row.informe}`}</label>
                </Tooltip>
        },
        {
            field: 'marca', headerName: 'Marca', headerAlign: 'center', flex: 1,
            renderCell: (params) =>
                <Tooltip title={`${params.row.marca}`} arrow>
                    <label>{`${params.row.marca}`}</label>
                </Tooltip>
        },
    ]

    const rows = [];
    historial?.map(anexo => {
        if (anexo?.prefijo != '') {
            rows.push({
                id: uuidv4(), informe: anexo?.informe, marca: anexo?.marca
            })
        }
        else return null
    })


    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModalHistorial} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description" >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" className='text-danger' style={{ color: "white" }}>
                            <h3 style={{ color: "black", fontFamily: "Montserrat", fontWeight: "bold", textAlign: 'center' }}>Detalle de informes y marcas</h3>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" style={{ color: "black", textAlign: 'justify' }}>
                            <Box sx={{ height: 300, width: '100%', mt: 2 }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    disableColumnMenu={true}
                                    pageSize={8}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#c88b3e',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <button className={`btn btn-outline-success`} style={{ width: '50%' }} onClick={() => handleCloseModal()}>Aceptar</button>
                        </Typography>
                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(HistorialMarcarioComponent)
